import { configuration } from  '../ReadConfig';

// Commenting the following lines as the values will be read from OCP config file

const CLIENT_ID = configuration.react_app_client_id || '0oa9egnctpAtDTcvS1d7';
const ISSUER = configuration.react_app_issuer || 'https://regionscommercialfeddev.regionstest.com/oauth2/aus4wfe3w81Dzm89L1d7';
const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const REDIRECT_URI = `${window.location.origin}/login/callback`;
const LOGOUT_URI = configuration.react_app_logout_uri;
// const USE_OKTA = configuration.react_app_use_okta === "False";
const USE_OKTA = configuration.react_app_use_okta;


console.log ('CLIENT_ID values from config: ', CLIENT_ID );
console.log ('Issuer values from config: ', ISSUER );
console.log ('REDIRECT_URI values from config: ', REDIRECT_URI );
console.log ('USE_OKTA values from config: ', USE_OKTA );
console.log ('Value from secrets: ', process.env.REACT_APP_CLIENT_SECRET);


let USE_INTERACTION_CODE = false;
if (process.env.USE_INTERACTION_CODE === 'true') {
    USE_INTERACTION_CODE = true;
}

export default {
    oidc: {
        clientId: CLIENT_ID,
        issuer: ISSUER,
        redirectUri: REDIRECT_URI,
        scopes: ['openid', 'itrel'],
        pkce: true,
        disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK === true,
        useInteractionCode: USE_INTERACTION_CODE === true,
        responseMode: 'query',
        postLogoutRedirectUri: LOGOUT_URI
    },
    USE_OKTA: USE_OKTA
};